export enum MaintenanceScheduleStatus {
  Scheduled = "scheduled",
  Completed = "completed",
  Canceled = "canceled",
  NoShow = "no_show" 
}

export enum MaintenanceScheduleType {
    Preventive = "preventive",
      Corrective = "corrective",
        Other = "other",
}
export type IMaintenanceSchedule = {
  _id?: string | null;
  typeReview: MaintenanceScheduleType | string;
  licensePlate: string;
  companyId: string;
  author: string;
  renterName: string;
  renterPhone: string;
  renterVehicle: string;
  scheduledDate: Date | string;
  scheduledTime: string;
  status: MaintenanceScheduleStatus | string;
  notes: string | null;
  updatedAt: Date;
  createdAt: Date;
};
